import ClientCard from "../../../Common/ClientCard/ClientCard";
import { cardData } from "./CardsData";
import styles from "./ClientCards.module.css";

const CardsList = () => {
  return (
    <div className={styles.container}>
      {cardData.map((card, idx) => (
        <ClientCard
          key={idx}
          image={card.image}
          title={card.title}
          description={card.description}
        />
      ))}
    </div>
  );
};

export default CardsList;
